import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { httpParamMapper } from '@rma/public/generic/util/http';
import { Observable } from 'rxjs';
import { ActivationTokenDetails } from '../activation-token-details';
@Injectable({
  providedIn: 'root',
})
export class ActivationService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public activateFromToken(
    claimToken: string,
    acceptTermsAndConditions: boolean,
  ): Observable<{ userToken: string; redirectUrl: string | undefined }> {
    const url = this.rmaApiUrl('Profile/Activate/Token');
    return this.httpClient.post<{
      userToken: string;
      redirectUrl: string | undefined;
    }>(url, { claimToken, acceptTermsAndConditions });
  }

  public getDetailsFromToken(token: string): Observable<ActivationTokenDetails> {
    const params = { params: httpParamMapper({ token }) };
    const url = this.rmaApiUrl(`Profile/Activate/Token/Details`);
    return this.httpClient.get<ActivationTokenDetails>(url, params);
  }
}
